import React, {useState, Fragment, useEffect} from 'react';
import { Card, CardContent, Typography, } from '@mui/material';
import { Cancel, Edit, Save } from '@mui/icons-material';
import {useDispatch} from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { nuevoOActualizarRegistroPersonalizado, setearDatosAlStore } from 'store/actions/customAction';
import Formulario from 'components/formulario';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';
import { functions } from 'constantes';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import { useStyles } from './estilos';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import { catalogoDeCandidaturasEleccion } from 'constantes/globalsStates';

let idRegistroGeneral = null;
const FormularioParaAsignacion = ({ openFullScreenDialog, handleClose, datosDelMedio, manejadorAgregarAsignacion}) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    useEffect ( () => {
        const copiaElementos = Object.assign({}, elements)
        switch (datosDelMedio.idEleccion) {
            case catalogoDeCandidaturasEleccion.PRESIDENTE:     // 1 = presidente
                copiaElementos.espacioDisponibleMedio.value = datosDelMedio.disponibilidadEncontrada[0]?.espacioPresidente
            break;
            case catalogoDeCandidaturasEleccion.CORPORACIONES: // 2 = coporracoines municipal
                copiaElementos.espacioDisponibleMedio.value = datosDelMedio.disponibilidadEncontrada[0]?.espacioAlcalde
            break;
            case catalogoDeCandidaturasEleccion.DIPUTACIONES: // 3 = dioutaciones
                copiaElementos.espacioDisponibleMedio.value = datosDelMedio.disponibilidadEncontrada[0]?.espacioDiputado
            break;
            default:
                copiaElementos.espacioDisponibleMedio.value = ""
                break;
        }
        setElements(copiaElementos)
    }, []);

    const [responseData, setResponseData] = useState({ errorType: 'error', messageType: '', openResponse: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
    const [gestionarDeEspaciosDeMedios] = useState("gestionarDeEspaciosDeMedios");
    const {nivelCobertura, nombreMedio, tipoCandidatura, nombreMedioDeComunicacion, empresa, cantidadEditar, idRegistro} = datosDelMedio;
    idRegistroGeneral = idRegistro;

    const [elements, setElements] = React.useState({
        corporacion: {
            idelement: "corporacion", value: empresa?.empresa?.nombreEmpresa || "", label: "Corporación", pattern:"", validators: ['required'], errorMessages:[''], isError:false, elementType:'texto', name:"corporacion", 'disabled': true, width: '50%'
        },
        canal: {
            idelement: "canal", value: nombreMedioDeComunicacion || "", label: "Canal", pattern:"", validators: ['required'], errorMessages:[''], isError:false, elementType:'texto', name:"canal", 'disabled': true, width: '50%'
        },
        espacioDisponibleMedio: {
            idelement: "espacioDisponibleMedio", value: "", label: "Espacio disponible del medio", pattern:"", validators: ['required'], errorMessages:[''], isError:false, elementType:'texto', name:"espacioDisponibleMedio", 'disabled': true, width: '50%'
        },
        cantidadAsginar: {
            idelement: "cantidadAsginar", value: idRegistro ? cantidadEditar : "", label: "Cantidad a asginar *", pattern:"^([1-9]{1})([0-9]{1,2})?$", validators: ['required'], errorMessages:['El campo es requerido y solo números'], isError:false, elementType:'texto', name:"cantidadAsginar", 'disabled': false, width: '50%'
        },
        acciones:{
            idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
        },
    });

    const cancelarAccion = () => {
        dispatch(setearDatosAlStore({ dispatchAction : nombreDeAcciones.LIMPIAR_TODO_EL_REDUCER}));
        handleClose(true);
    };

    const guardarDatos = async (dataForm) => {
        setcargandoSolicitud(true);
        const {cantidadAsginar} = dataForm;
        const {diaContratar, idEleccion, idMedioDeComunicacion} = datosDelMedio;

        const datosAGuardar = {
            "espacioPorEleccion": [
                {
                "espacioPorDia": [
                    {
                    "espaciosPorAsignar": Number(cantidadAsginar),
                    "fechaAsignacion": functions.formatearFechaDD_MM_YYYY(diaContratar)
                    }
                ],
                idEleccion
                }
            ],
            "idMedio": idMedioDeComunicacion
        }

        let respuesta = {};

        if(idRegistroGeneral) {
            const datosEdicion = { controller: gestionarDeEspaciosDeMedios, action: "editar", data: {}, nombreDelMetodo: `editar/${idRegistroGeneral}/${Number(cantidadAsginar)}` };
            respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosEdicion));
        } else {
            const datosAEnviar = { controller: gestionarDeEspaciosDeMedios, action: "crear", data: datosAGuardar, nombreDelMetodo: "" };
            respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
        }

        setcargandoSolicitud(false);
        if(respuesta?.error) return changeDataResponse('error', `${respuesta?.error?.message}` || "Ocurrió un inconveniente. Intente de nuevo!", true)

        manejadorAgregarAsignacion(dataForm, datosDelMedio, respuesta, idRegistroGeneral, cantidadAsginar)
    }

    const [buttonList]= React.useState({
        "guardarDatos":{"label": idRegistroGeneral ? "Editar" : "Agregar", "icon": idRegistroGeneral ? <Edit /> : <Save />, "callback":guardarDatos,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelar":{"label":"Cancelar", "icon": <Cancel />,"callback":cancelarAccion,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (errorType, messageType, openResponse = false) => setResponseData({errorType,messageType,openResponse,});

    const { errorType, messageType, openResponse} = responseData;

    return (
      <DialogoPantallaCompleta
        openFullScreenDialog={openFullScreenDialog}
        handleClose={handleClose}
        title={idRegistroGeneral ? "EDITAR ESPACIO PUBLICITARIO CONTRATADO" : "CONTRATAR ESPACIO PUBLICITARIO"}
        fullscreen={false}
        maxWidth={"md"}
      >
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose}/>
            <Card>
                <Typography className={classes.tituloFormulario}> {tipoCandidatura || ""} - {nombreMedio || ""} - ({nivelCobertura?.name || ""}) </Typography>
                <Typography className={classes.subtituloFormulario}> Para el día: {functions.FormatearFecha(datosDelMedio?.diaContratar || "")} </Typography>
                <CardContent>
                    <Formulario
                        elements={elements}
                        buttonList={buttonList}
                    />
                </CardContent>
            </Card>
        </Fragment>
      </DialogoPantallaCompleta>
    );
}

export default FormularioParaAsignacion;